import { render, staticRenderFns } from "./userForm.vue?vue&type=template&id=08e641ac&"
import script from "./userForm.vue?vue&type=script&lang=js&"
export * from "./userForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports